<template>
  <Head title="Detail Slider" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs
          :breadcrumbs="[
            { name: 'Dashboard', href: route('dashboard') },
            {
              name: `Slider`,
              href: route('sliders.index'),
            },
            {
              name: `${slider.data.judul}`,
            },
          ]"
        />

        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8">
          <!-- Detail Card -->
          <div class="order-2 col-span-1 space-y-6 lg:order-1">
            <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
              <div
                class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4"
              >
                <h2
                  class="flex items-center text-lg font-bold text-white sm:text-xl"
                >
                  <i class="mr-2 fa-solid fa-images sm:mr-3"></i>
                  Detail Slider
                </h2>
              </div>
              <div class="p-4 sm:p-6">
                <dl class="space-y-4">
                  <div>
                    <dt class="text-sm font-medium text-gray-500">Judul</dt>
                    <dd class="mt-1 text-sm font-semibold text-gray-900">
                      {{ slider.data.judul }}
                    </dd>
                  </div>

                  <div>
                    <dt class="text-sm font-medium text-gray-500">Deskripsi</dt>
                    <dd class="mt-1 text-sm text-gray-900">
                      {{ slider.data.deskripsi || "Tidak ada deskripsi" }}
                    </dd>
                  </div>

                  <div class="grid grid-cols-2 gap-4">
                    <div>
                      <dt class="text-sm font-medium text-gray-500">Urutan</dt>
                      <dd class="mt-1 text-sm text-gray-900">
                        {{ slider.data.urutan }}
                      </dd>
                    </div>
                    <div>
                      <dt class="text-sm font-medium text-gray-500">Status</dt>
                      <dd class="mt-1">
                        <span
                          :class="
                            slider.data.status
                              ? 'inline-flex items-center px-2 py-1 text-xs font-medium text-green-800 bg-green-100 rounded-full'
                              : 'inline-flex items-center px-2 py-1 text-xs font-medium text-red-800 bg-red-100 rounded-full'
                          "
                        >
                          {{ slider.data.status ? "Aktif" : "Tidak Aktif" }}
                        </span>
                      </dd>
                    </div>
                  </div>
                </dl>

                <!-- Action Buttons -->
                <div
                  class="pt-4 mt-6 border-t border-gray-200"
                  v-if="$page.props.auth.user"
                >
                  <div
                    class="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-3"
                  >
                    <button
                      v-if="$page.props.can.slider_edit"
                      @click="editDokumen(slider.data.idslider)"
                      class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-indigo-600 transition-colors duration-200 bg-indigo-100 border border-transparent rounded-lg hover:bg-indigo-200 hover:text-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <i class="mr-2 fa-solid fa-pen"></i>
                      Edit Slider
                    </button>

                    <button
                      v-if="$page.props.can.slider_edit"
                      @click="editFile(slider.data.idslider)"
                      class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-purple-600 transition-colors duration-200 bg-purple-100 border border-transparent rounded-lg hover:bg-purple-200 hover:text-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
                    >
                      <i class="mr-2 fa-solid fa-image"></i>
                      Edit Gambar
                    </button>

                    <button
                      v-if="$page.props.can.slider_delete"
                      @click="confirmDelete(slider.data.idslider)"
                      class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-red-600 transition-colors duration-200 bg-red-100 border border-transparent rounded-lg hover:bg-red-200 hover:text-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    >
                      <i class="mr-2 fa-solid fa-trash"></i>
                      Hapus
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Image Preview -->
          <div class="order-1 col-span-1 lg:col-span-2 lg:order-2">
            <div class="mb-4 sm:mb-6">
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
              >
                <div>
                  <h3 class="text-lg font-semibold text-gray-900">
                    Preview Gambar
                  </h3>
                  <p class="mt-1 text-sm text-gray-600">
                    Tampilan gambar slider
                  </p>
                </div>
              </div>
            </div>

            <div
              class="overflow-hidden bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
            >
              <div class="p-6">
                <div v-if="slider.data.gambar" class="text-center">
                  <img
                    :src="slider.data.gambar"
                    :alt="slider.data.judul"
                    class="h-auto max-w-full mx-auto rounded-lg shadow-lg"
                    style="max-height: 500px"
                  />
                </div>
                <div
                  v-else
                  class="flex items-center justify-center h-64 bg-gray-100 rounded-lg"
                >
                  <div class="text-center">
                    <i class="text-4xl text-gray-400 fa-solid fa-image"></i>
                    <p class="mt-2 text-sm text-gray-500">Tidak ada gambar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modals -->
        <ModalEditSlider
          v-model:isOpen="isModalOpen"
          :title="'Edit Slider'"
          :slider="viewslider"
        />
        <ModalFile
          v-model:isOpen="isModalFile"
          :title="'Edit File'"
          :slider="viewslider"
        />
      </div>
    </template>
  </Container>
</template>

<script setup>
import { Head, router } from "@inertiajs/vue3";
import { defineProps, ref, inject } from "vue";
import ModalEditSlider from "@/Components/Sliders/ModalEditSlider.vue";
import ModalFile from "@/Components/Sliders/ModalFile.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import Swal from "sweetalert2";
const route = inject('route');

const props = defineProps({
  slider: {
    type: Object,
    required: true,
  },
});

const isModalOpen = ref(false);
const isModalFile = ref(false);
const viewslider = ref(null);

const editDokumen = async (idslider) => {
  try {
    const response = await fetch(`/viewslider/${idslider}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewslider.value = data.slider;
    isModalOpen.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    Swal.fire({
      title: "Error!",
      text: "Gagal memuat data slider",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};

const editFile = async (idslider) => {
  try {
    const response = await fetch(`/viewslider/${idslider}`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    viewslider.value = data.slider;
    isModalFile.value = true;
  } catch (error) {
    console.error("Error fetching data:", error.message);
    Swal.fire({
      title: "Error!",
      text: "Gagal memuat data slider",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};

const confirmDelete = (iddok) => {
  Swal.fire({
    title: "Apakah Anda yakin?",
    text: "Data slider akan dihapus permanen!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#ef4444",
    cancelButtonColor: "#6b7280",
    confirmButtonText: "Ya, hapus!",
    cancelButtonText: "Batal",
  }).then((result) => {
    if (result.isConfirmed) {
      router.delete(`/sliders/${iddok}`, {
        onSuccess: () => {
          Swal.fire({
            title: "Terhapus!",
            text: "Slider berhasil dihapus",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            router.visit(route("sliders.index"));
          });
        },
        onError: () => {
          Swal.fire({
            title: "Error!",
            text: "Gagal menghapus slider",
            icon: "error",
            confirmButtonText: "OK",
          });
        },
        preserveScroll: true,
      });
    }
  });
};
</script>
